import React from "react";

const CalendarIconOutlineRounded = ({
  primaryColor = "#5062F0",
  size = 44,
  title = "Badge Calendar (Outline)",
  ...svgProps
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label={title}
    {...svgProps}
  >
    {title ? <title>{title}</title> : null}

    <rect x="0.5" y="0.5" width="43" height="43" rx="11.5" stroke={primaryColor} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0278 11C18.4075 11 18.7153 11.3078 18.7153 11.6875V13.0625H25.2847V11.6875C25.2847 11.3078 25.5925 11 25.9722 11C26.3519 11 26.6597 11.3078 26.6597 11.6875V13.0625H28.9514C30.4522 13.0625 31.625 14.3184 31.625 15.8125V30.25C31.625 31.7441 30.4522 33 28.9514 33H15.0486C13.5478 33 12.375 31.7441 12.375 30.25V15.8125C12.375 14.3184 13.5478 13.0625 15.0486 13.0625H17.3403V11.6875C17.3403 11.3078 17.6481 11 18.0278 11ZM17.3403 14.4375H15.0486C14.3556 14.4375 13.75 15.0284 13.75 15.8125V19.25H30.25V15.8125C30.25 15.0284 29.6444 14.4375 28.9514 14.4375H26.6597V15.8125C26.6597 16.1922 26.3519 16.5 25.9722 16.5C25.5925 16.5 25.2847 16.1922 25.2847 15.8125V14.4375H18.7153V15.8125C18.7153 16.1922 18.4075 16.5 18.0278 16.5C17.6481 16.5 17.3403 16.1922 17.3403 15.8125V14.4375ZM30.25 20.625H13.75V30.25C13.75 31.0341 14.3556 31.625 15.0486 31.625H28.9514C29.6444 31.625 30.25 31.0341 30.25 30.25V20.625Z"
      fill={primaryColor}
    />
  </svg>
);

export default React.memo(CalendarIconOutlineRounded);
